<template>
  <div class="fl-sym-px-4">
    <div
      class="fl-sym-mt-5 xs:fl-sym-mt-12 fl-sym-text-primary fl-sym-text-xxs"
    >
      LOG Out
    </div>
    <div
      class="fl-sym-text-black fl-sym-text-5xl fl-sym-leading-tight fl-sym-font-semibold fl-sym-mb-2"
    >
     Goodbye
    </div>
    <div class="fl-sym-text-intermediate fl-sym-text-lg">
      Click LogOff?
    </div>
    <form
      class="fl-sym-mt-20 xnpms:fl-sym-mt-16"
      @submit.prevent="submit"
      method="post"
    >
      <div class="fl-sym-mt-3 xs:fl-sym-mt-15 fl-sym-mb-2">
        <button
          type="submit"
          class="fl-sym-bg-primary fl-sym-rounded-full fl-sym-text-white fl-sym-p-3 fl-sym-w-full fl-sym-text-sm"
        >
          Log out
        </button>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable no-alert, no-console */
import * as openModel from "../../gen/openapi-js/dist/index";
import RestAuthApi from '../../gen/openapi-js/dist/api/RestAuthApi';
import { mapState } from 'vuex';
import {UserLogin} from "@/gen/openapi-js/src";
export default {
  data(){
    return {
      email : "",
      password : "",
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  },
  methods: {
    forgetPassword() {
      this.$router.push({ name: process.env.VUE_APP_AUTH_FORGET_PASSWORD });
    },

    async submit() {
      await this.$store.dispatch('auth/logout')
    },
  },
};
</script>
<style>
.error {
  top: 460px;
  left: 20px;
  width: 366px;
  height: 16px;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  opacity: 1;
  font: "SFProDisplay-Regular";
  font-size: 16px;
  color: #ff3a19;
}

border-red {
  border-color: #ff3a19;
}
</style>